import { CellContext } from '@tanstack/react-table';
import { FlagIcon, Skeleton, tableHelpers } from '@round/creatorbase-ui';
import { getMeta, NO_VALUE, OutreachResultRow } from '../../../../helpers';
import styles from './LocationCell.module.css';

type Props = CellContext<tableHelpers.WithLoadingRow<OutreachResultRow>, unknown>;

export const LocationCell = ({ row: { original }, table }: Props) => {
    const { isLoading } = getMeta(table);

    if (tableHelpers.isLoadingRow(original) || isLoading) {
        return <Skeleton className={styles.skeleton} />;
    }

    if (!original.location) {
        return NO_VALUE;
    }

    return (
        <span className={styles.container}>
            <FlagIcon countryCode={original.location.country_code} />
            <span className={styles.name}>{original.location.country_name}</span>
        </span>
    );
};
